export const calculateResponsiveSize = (px) => `${px / 15.4}vw`
